import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { C } from "../lib/constants";
import { Btn } from "./ui/Btn";
import { TopNav } from "./ui/TopNav";

export const CalificarTrabajo = ({solicitudId, user, setScreen, onDone}) => {
  const [solicitud,    setSolicitud]    = useState(null);
  const [loading,      setLoading]      = useState(true);
  const [yaCalificado, setYaCalificado] = useState(false);
  const [elegible,     setElegible]     = useState(false);
  const [rating,       setRating]       = useState(5);
  const [calidad,      setCalidad]      = useState(5);
  const [puntualidad,  setPuntualidad]  = useState(5);
  const [precioR,      setPrecioR]      = useState(5);
  const [limpieza,     setLimpieza]     = useState(5);
  const [comment,      setComment]      = useState("");
  const [sending,      setSending]      = useState(false);
  const [sent,         setSent]         = useState(false);
  const [err,          setErr]          = useState("");

  useEffect(() => {
    if (!solicitudId) { setLoading(false); return; }
    supabase.from("solicitudes").select("*").eq("id", solicitudId).maybeSingle()
      .then(({ data }) => {
        setSolicitud(data || null);
        if (data) {
          setYaCalificado(data.estado === "completada");
          setElegible(
            (data.cliente_id === user?.id || data.cliente_user_id === user?.id) &&
            ["completada","en_progreso"].includes(data.estado) &&
            data.estado !== "completada"
          );
        }
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [solicitudId, user?.id]);

  const enviarResena = async () => {
    if (!comment.trim()) { setErr("Escribe un comentario."); return; }
    if (!solicitud?.id)  { setErr("Solicitud no válida."); return; }
    setSending(true); setErr("");
    try {
      const { error: re } = await supabase.from("resenas").insert([{
        solicitud_id:    solicitud.id,
        autor_id:        user.id,
        destinatario_id: solicitud.trabajador_user_id || solicitud.trabajador_id || null,
        calificacion:    rating,
        comentario:      comment.trim(),
        tipo:            "cliente_a_trabajador",
      }]);
      if (re) throw re;

      await supabase.from("solicitudes")
        .update({ estado: "completada", updated_at: new Date().toISOString() })
        .eq("id", solicitud.id);

      // Actualizar calificación promedio del trabajador
      const destId = solicitud.trabajador_user_id || solicitud.trabajador_id;
      const { data: todas } = await supabase.from("resenas").select("calificacion")
        .eq("destinatario_id", destId || "")
        .eq("tipo", "cliente_a_trabajador");
      if (todas?.length && destId) {
        const prom = todas.reduce((a,r)=>a+r.calificacion,0)/todas.length;
        await supabase.from("trabajadores")
          .update({ calificacion: prom, "reseñas": todas.length })
          .eq("user_id", solicitud.trabajador_user_id || destId);
      }
      setSent(true);
    } catch(e) {
      setErr(e.message || "Error al enviar.");
    } finally {
      setSending(false);
    }
  };

  if (loading) return (
    <div style={{minHeight:"100vh",background:C.bg,display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{textAlign:"center",color:C.muted}}>
        <div style={{fontSize:36,marginBottom:8}}>⏳</div>Cargando...
      </div>
    </div>
  );

  if (!user) return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:80}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Calificar trabajo"/>
      <div style={{maxWidth:480,margin:"0 auto",padding:"32px 20px",textAlign:"center"}}>
        <div style={{fontSize:52,marginBottom:12}}>🔐</div>
        <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:800,color:C.text,marginBottom:8}}>Inicia sesión primero</div>
        <div style={{color:C.sub,fontSize:13,marginBottom:20}}>Necesitas entrar con la misma cuenta con que contrataste el servicio.</div>
        <Btn full color={C.accent} onClick={()=>setScreen("cliente-login")}>Iniciar sesión</Btn>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:"100vh",background:C.bg,paddingBottom:100}}>
      <TopNav setScreen={setScreen} back="landing" backLabel="Inicio" title="Califica el trabajo"/>
      <div style={{maxWidth:480,margin:"0 auto",padding:"24px 20px"}}>

        {sent ? (
          <div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{fontSize:72,marginBottom:16}}>⭐</div>
            <div style={{fontFamily:"'Georgia',serif",fontSize:26,fontWeight:800,color:C.green,marginBottom:8}}>¡Gracias por tu reseña!</div>
            <div style={{color:C.sub,fontSize:14,lineHeight:1.6,marginBottom:24}}>Tu opinión ayuda a {solicitud?.trabajador_nombre || "el trabajador"} y a toda la comunidad Ficio.</div>
            <Btn full color={C.accent} onClick={onDone}>Ir al inicio</Btn>
          </div>
        ) : yaCalificado ? (
          <div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{fontSize:52,marginBottom:12}}>✅</div>
            <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,color:C.text,marginBottom:8}}>Ya enviaste tu reseña</div>
            <div style={{color:C.sub,fontSize:13,marginBottom:20}}>Solo se puede calificar una vez por trabajo.</div>
            <Btn full outline color={C.accent} onClick={onDone}>Volver al inicio</Btn>
          </div>
        ) : !elegible ? (
          <div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{fontSize:52,marginBottom:12}}>🔒</div>
            <div style={{fontFamily:"'Georgia',serif",fontSize:20,fontWeight:800,color:C.text,marginBottom:8}}>No disponible</div>
            <div style={{color:C.sub,fontSize:13,marginBottom:20}}>Este enlace no es válido para tu cuenta, o el trabajo aún no ha finalizado.</div>
            <Btn full outline color={C.accent} onClick={onDone}>Ir al inicio</Btn>
          </div>
        ) : (
          <>
            <div style={{background:`linear-gradient(135deg,${C.accent},${C.accentD})`,borderRadius:20,padding:20,color:"#fff",marginBottom:20,boxShadow:`0 6px 20px ${C.accent}40`}}>
              <div style={{fontSize:32,marginBottom:8}}>⭐</div>
              <div style={{fontFamily:"'Georgia',serif",fontSize:22,fontWeight:800,marginBottom:4}}>Califica a {solicitud?.trabajador_nombre || "el trabajador"}</div>
              <div style={{fontSize:13,opacity:0.88}}>Trabajo: {solicitud?.descripcion || solicitud?.oficio || "Servicio contratado"}</div>
            </div>

            {err && <div style={{background:C.redL,border:`1px solid ${C.red}30`,borderRadius:10,padding:"10px 12px",color:C.red,fontSize:12,marginBottom:14}}>{err}</div>}

            <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:20,marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:12}}>Calificación general</div>
              <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:6}}>
                {[1,2,3,4,5].map(s=>(
                  <button key={s} onClick={()=>setRating(s)} style={{background:"none",border:"none",cursor:"pointer",fontSize:36,opacity:s<=rating?1:0.2,transform:s<=rating?"scale(1.1)":"scale(1)",transition:"all 0.15s"}}>⭐</button>
                ))}
              </div>
              <div style={{textAlign:"center",color:C.accent,fontWeight:800,fontSize:18}}>{["","Malo","Regular","Bueno","Muy bueno","Excelente"][rating]}</div>
            </div>

            <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:20,marginBottom:14,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:14}}>Detalles del servicio</div>
              {[
                ["🔨 Calidad del trabajo", calidad, setCalidad],
                ["⏰ Puntualidad",         puntualidad, setPuntualidad],
                ["💰 Precio justo",        precioR, setPrecioR],
                ["🧹 Limpieza",            limpieza, setLimpieza],
              ].map(([label, val, setter]) => (
                <div key={label} style={{marginBottom:14}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <span style={{color:C.text,fontSize:13}}>{label}</span>
                    <span style={{color:C.accent,fontWeight:800,fontSize:13}}>{val}/5</span>
                  </div>
                  <div style={{display:"flex",gap:6}}>
                    {[1,2,3,4,5].map(s=>(
                      <button key={s} onClick={()=>setter(s)}
                        style={{flex:1,height:8,borderRadius:6,border:"none",cursor:"pointer",
                          background:s<=val?C.accent:C.faint,transition:"background 0.15s"}}/>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:18,padding:20,marginBottom:20,boxShadow:"0 2px 8px rgba(0,0,0,0.05)"}}>
              <div style={{color:C.sub,fontSize:11,fontWeight:700,letterSpacing:0.8,textTransform:"uppercase",marginBottom:10}}>Tu experiencia</div>
              <textarea
                value={comment}
                onChange={e=>setComment(e.target.value)}
                placeholder="¿Cómo fue el trabajo? Cuéntale a otros clientes tu experiencia real..."
                rows={4}
                style={{width:"100%",background:C.bg,border:`1.5px solid ${C.border}`,borderRadius:12,color:C.text,padding:"12px 14px",fontSize:13,resize:"none",boxSizing:"border-box",outline:"none",fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif"}}
                onFocus={e=>e.target.style.borderColor=C.accent}
                onBlur={e=>e.target.style.borderColor=C.border}
              />
            </div>

            <Btn full color={C.accent} onClick={enviarResena}>
              {sending ? "Enviando..." : "Enviar reseña verificada ✓"}
            </Btn>
            <div style={{color:C.muted,fontSize:11,textAlign:"center",marginTop:10}}>Tu reseña quedará vinculada a este trabajo y será pública en el perfil del trabajador.</div>
          </>
        )}
      </div>
    </div>
  );
};
